<app-proposta-viewer *ngIf="imagesLoaded | async" [proposta]="this.proposta" (update)="this.update($event)"></app-proposta-viewer>